@let data = court();

@if (data.clerk?.photo) {
  @if (!clerkPhotoLoaded) {
    <app-ccs-skeleton height="65px" width="65px" radius="full" />
  }

  <img
    [src]="data.clerk?.photo"
    [alt]="data.clerk?.name"
    class="size-16 rounded-full object-cover"
    [class.hidden]="!clerkPhotoLoaded"
    (load)="clerkPhotoLoaded = true" />
}
